import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Shared/Buttons/Button';
import { makeStyles } from "@material-ui/core/styles";

import 'react-toastify/dist/ReactToastify.css';
function ConfigurationPage(props) {

    const classes = useStyles();

    return (
        <div className="page-container page-container--narrow">
            <div className={classes.linkContainer}>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        Create a new dropdown.
                    </div>
                    <Link to='/createdropdown' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}Create a dropdown</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        Manage existing dropdowns. (Edit, delete,...)
                    </div>
                    <Link to='/dropdownoverview' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}Manage dropdowns</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        Create a new API.
                    </div>
                    <Link to='/createapi' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}Create API</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        Manage existing APIs. (Edit or delete.)
                    </div>
                    <Link to='/externalapioverview' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}Manage APIs</Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ConfigurationPage;
const useStyles = makeStyles((theme) => ({
    linkContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginTop: "160px",
    },
    boxStyle: {
        display: "flex",
        justifyContent: "space-between",
        background: "#FFFFFF",
        border: "1px solid var(--color-border-light)",
        borderRadius: "8px",
        padding: "16px",
        paddingLeft: '24px',
    },
    menuItem: {
        color: '#1D3557',

        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
            width: '50% !important',
        },
        [theme.breakpoints.up('sm')]: {
            width: '100% !important',
            fontSize: '1.2rem',
        },
        display: "flex",
        alignItems: "center",
    },
    link: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5%',
            width: '50% !important',
            minWidth: '50% !important',
        },
    },
    linkButton: {
        minWidth: '200px',
    },
}));